export const LIST_CASHIER_REQUEST = 'LIST_CASHIER_REQUEST'
export const LIST_CASHIER_SUCCESS = 'LIST_CASHIER_SUCCESS'
export const LIST_CASHIER_FAIL = 'LIST_CASHIER_FAIL'

export const DOWNLOAD_REGISTRATION_PATIENT_REQUEST =
  'DOWNLOAD_REGISTRATION_PATIENT_REQUEST'
export const DOWNLOAD_REGISTRATION_PATIENT_SUCCESS =
  'DOWNLOAD_REGISTRATION_PATIENT_SUCCESS'
export const DOWNLOAD_REGISTRATION_PATIENT_FAIL =
  'DOWNLOAD_REGISTRATION_PATIENT_FAIL'

export const LIST_TRANSACTION_BY_TRANSACTION_ID_REQUEST =
  'LIST_TRANSACTION_BY_TRANSACTION_ID_REQUEST'
export const LIST_TRANSACTION_BY_TRANSACTION_ID_SUCCESS =
  'LIST_TRANSACTION_BY_TRANSACTION_ID_SUCCESS'
export const LIST_TRANSACTION_BY_TRANSACTION_ID_FAIL =
  'LIST_TRANSACTION_BY_TRANSACTION_ID_FAIL'

export const CREATE_BILLING_TRANSACTION_REQUEST =
  'CREATE_BILLING_TRANSACTION_REQUEST'
export const CREATE_BILLING_TRANSACTION_SUCCESS =
  'CREATE_BILLING_TRANSACTION_SUCCESS'
export const CREATE_BILLING_TRANSACTION_FAIL = 'CREATE_BILLING_TRANSACTION_FAIL'

export const CANCEL_BILLING_TRANSACTION_REQUEST =
  'CANCEL_BILLING_TRANSACTION_REQUEST'
export const CANCEL_BILLING_TRANSACTION_SUCCESS =
  'CANCEL_BILLING_TRANSACTION_SUCCESS'
export const CANCEL_BILLING_TRANSACTION_FAIL = 'CANCEL_BILLING_TRANSACTION_FAIL'

export const DETAIL_TRANSACTION_BY_TRANSACTION_ID_REQUEST =
  'DETAIL_TRANSACTION_BY_TRANSACTION_ID_REQUEST'
export const DETAIL_TRANSACTION_BY_TRANSACTION_ID_SUCCESS =
  'DETAIL_TRANSACTION_BY_TRANSACTION_ID_SUCCESS'
export const DETAIL_TRANSACTION_BY_TRANSACTION_ID_FAIL =
  'DETAIL_TRANSACTION_BY_TRANSACTION_ID_FAIL'

export const DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_REQUEST =
  'DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_REQUEST'
export const DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_SUCCESS =
  'DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_SUCCESS'
export const DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_FAIL =
  'DELETE_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_FAIL'

export const PRINT_INVOICE_PATIENT_REQUEST = 'PRINT_INVOICE_PATIENT_REQUEST'
export const PRINT_INVOICE_PATIENT_SUCCESS = 'PRINT_INVOICE_PATIENT_SUCCESS'
export const PRINT_INVOICE_PATIENT_FAIL = 'PRINT_INVOICE_PATIENT_FAIL'

export const FINISH_TRANSACTION_BY_ID_REQUEST =
  'FINISH_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_REQUEST'
export const FINISH_TRANSACTION_BY_ID_SUCCESS =
  'FINISH_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_SUCCESS'
export const FINISH_TRANSACTION_BY_ID_FAIL =
  'FINISH_TRANSACTION_BY_TRANSACTION_PAYMENT_ID_FAIL'

export const ADD_PAYMENT_TRANSACTION_REQUEST = 'ADD_PAYMENT_TRANSACTION_REQUEST'
export const ADD_PAYMENT_TRANSACTION_SUCCESS = 'ADD_PAYMENT_TRANSACTION_SUCCESS'
export const ADD_PAYMENT_TRANSACTION_FAIL = 'ADD_PAYMENT_TRANSACTION_FAIL'

export const CREATE_EXCESS_CASHIER_REQUEST = 'CREATE_EXCESS_CASHIER_REQUEST'
export const CREATE_EXCESS_CASHIER_SUCCESS = 'CREATE_EXCESS_CASHIER_SUCCESS'
export const CREATE_EXCESS_CASHIER_FAIL = 'CREATE_EXCESS_CASHIER_FAIL'

export const GET_EXCESS_CASHIER_REQUEST = 'GET_EXCESS_CASHIER_REQUEST'
export const GET_EXCESS_CASHIER_SUCCESS = 'GET_EXCESS_CASHIER_SUCCESS'
export const GET_EXCESS_CASHIER_FAIL = 'GET_EXCESS_CASHIER_FAIL'

export const DELETE_EXCESS_CASHIER_REQUEST = 'DELETE_EXCESS_CASHIER_REQUEST'
export const DELETE_EXCESS_CASHIER_SUCCESS = 'DELETE_EXCESS_CASHIER_SUCCESS'
export const DELETE_EXCESS_CASHIER_FAIL = 'DELETE_EXCESS_CASHIER_FAIL'

export const LIST_PROMO_SUMMARY_REQUEST = 'LIST_PROMO_SUMMARY_REQUEST'
export const LIST_PROMO_SUMMARY_SUCCESS = 'LIST_PROMO_SUMMARY_SUCCESS'
export const LIST_PROMO_SUMMARY_FAIL = 'LIST_PROMO_SUMMARY_FAIL'

export const MEMBERSHIP_REGISTER_REQUEST = 'MEMBERSHIP_REGISTER_REQUEST'
export const MEMBERSHIP_REGISTER_SUCCESS = 'MEMBERSHIP_REGISTER_SUCCESS'
export const MEMBERSHIP_REGISTER_FAIL = 'MEMBERSHIP_REGISTER_FAIL'
